import React, {Component} from 'react';
import {Link} from 'react-router-dom'
import {AREA_ID_LIST} from "./configure/configure";
import '../area.css';

class Area extends Component {
    render() {
        const areaIdList = AREA_ID_LIST.map(area => {
            return <li key={area.id}>
                <Link to={"/schedule/" + area.id}>
                    {area.name}
                </Link>
            </li>;
        });

        return (
            <section className="area">
                <section id="section_region">
                    <p className="title">お住まいの地域を選択してください</p>
                    <p className="description">この設定は後で変更することができます</p>
                    <ul>
                        {areaIdList}
                    </ul>
                </section>
            </section>
        );
    }
}

export default Area;



// WEBPACK FOOTER //
// ./src/components/area.js